export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              追更助手
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              女神漫画网追更助手支持移动端访问，无论你是在通勤路上还是午休间隙，打开手机即可畅享下拉式追更体验。订阅心仪漫画后，更新自动推送，让追更融入你的日常生活节奏。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-100 border border-background-200">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-smartphone-line text-lg text-primary-600"></i>
                </div>
                <span className="text-sm font-medium text-foreground-800">移动端适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-100 border border-background-200">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-notification-3-line text-lg text-accent-600"></i>
                </div>
                <span className="text-sm font-medium text-foreground-800">更新提醒</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-100 border border-background-200">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-download-2-line text-lg text-secondary-600"></i>
                </div>
                <span className="text-sm font-medium text-foreground-800">离线缓存</span>
              </div>
            </div>
            <a
              href="#index"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 hover:bg-primary-600 text-white font-bold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即体验
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          <div className="flex-1 w-full max-w-[360px]">
            <div className="relative rounded-2xl overflow-hidden shadow-lg aspect-[9/16] max-w-[280px] mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20manga%20reading%20app%20interface%20with%20vertical%20scrolling%20comic%20panels%2C%20clean%20modern%20UI%20design%2C%20warm%20cream%20background%20on%20the%20phone%20screen%2C%20manga%20style%20artwork%20visible%2C%20device%20on%20a%20wooden%20surface%20with%20soft%20warm%20lighting%2C%20editorial%20product%20photography%20style&width=560&height=1000&seq=app-mockup-2026&orientation=portrait"
                alt="女神漫画网追更助手移动端"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}